import useCallMe from './use-call-me';

export {useCallMe};

export default useCallMe;
